import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as rs from '../../utils/resource'
import OzPageServicesSection from "./Section";
import {Button} from 'react-bootstrap'
import FooterComp from '../../components/Footer'
import OzContactBar from '../../components/OzContactUsBar'
import OzHero from "../../components/OzHero";

import './index.scss'
import OzContactUsModal from "../../components/OzContactUsModal";
import OzPageServicesSectionLeft from './SectionLeft'
import OzRectMenu from '../../components/OzRectMenu'

class PageServices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalVisible: false,
    }
  }

  componentDidMount() {}

  toggleContactUsModal = (val) => {
    this.setState({isModalVisible: !this.state.isModalVisible})
  }

  render() {
    const { sections } = rs.services_page
    const tempMenu = sections.map((section) => section.title)

    return (
      <>
        <OzHero hero={rs.first_screens.services} callbackModal={this.toggleContactUsModal} />
        {/* <OzQuote title={quote.title} className="oz-quote-services"/> */}
        {/* <section className="oz-page-service-sections" style={{backgroundImage: `url(assets/images/Services/Connect.png)`}}> */}
          <OzRectMenu menus={tempMenu}/>
          {sections.map((section, index) => {
            if (section.type === "right")
              return (
                <OzPageServicesSection
                  id={section.title.split(' ').join('-').toLowerCase()}
                  key={index}
                  section={section}
                  ref={section.title}
                />
              );
            return (
              <OzPageServicesSectionLeft
                id={section.title.split(' ').join('-').toLowerCase()}
                key={index}
                section={section}
                ref={section.title}
              />
            );
          }
          )}
        {/* </section> */}
        <OzContactBar section={rs.contact_us_bar.services} callbackModal={this.toggleContactUsModal} />
        <OzContactUsModal modal={rs.contactUsModal} confirm={rs.confirmModal} callbackModal={this.toggleContactUsModal} isModalVisible={this.state.isModalVisible} />
        <FooterComp />
      </>
    )
  }
}

PageServices.propTypes = {
};

PageServices.defaultProps = {};

export default withRouter(PageServices)
